export default {
  reload: 'Recharger',
  experiencingDifficulty: 'Nous rencontrons actuellement des difficultés!',
  underMaintenance: 'Nous mettons à jour nos services. Revenez voir bientôt!',
};
